//Dependencies............................................
import { Form, Dropdown, Button, Space, Collapse } from 'antd';
import { useEffect, useState } from 'react';
import { ItemType } from 'antd/es/menu/interface';

//Components..............................................

type InitialData_t = {
    baudrate_bps: string,
    lin_version: string,
}

const baudrateItems: ItemType[] = [
    { label: '2400', key: '2400' },
    { label: '9600', key: '9600' },
    { label: '10417', key: '10417' },
    { label: '19200', key: '19200' },
];

const versionItems: ItemType[] = [
    { label: 'v1.3', key: 'v1_3' },
    { label: 'v2.0', key: 'v2_0' },
    { label: 'v2.1', key: 'v2_1' },
    { label: 'v2.2A', key: 'v2_2A' },
];

export default  function Conf30LinBusConfigField({
    onChange,
    formData,
    }   :   {
    formData: InitialData_t,
    onChange: (newFormData: any) => void,
    })
{
    const [selectedConfig, setSelectedConfig] = useState<{ [key: string]: any }>({});

    useEffect(() => {
        if(!formData || Object.keys(formData).length === 0)
        {
            const initialConfig : InitialData_t = {
                baudrate_bps: '19200',
                lin_version: 'v2_1',
            }
            onChange(initialConfig);
        }else{
            setSelectedConfig(formData);
        }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setSelectedConfig(formData || {});
    }, [formData]);

    const updateConfig = (key: string, value: any) => {
        const updatedConfig = {
            ...formData,
            [key]: value,
        };
        setSelectedConfig(updatedConfig);
        onChange(updatedConfig);
    };

    return (
            <Collapse>
                <Collapse.Panel header="Lin Bus Config" key="0" >
                    <Form layout="horizontal">
                        <Form.Item label="Baudrate (bps)">
                            <Dropdown
                                menu={{
                                    items: baudrateItems,
                                    selectable: true,
                                    onClick: (e) => updateConfig('baudrate_bps', e.key),
                                }}
                            >
                                <Button>
                                    <Space>{selectedConfig.baudrate_bps || 'Select Baudrate'}</Space>
                                </Button>
                            </Dropdown>
                        </Form.Item>
                        <Form.Item label="LIN Version">
                            <Dropdown
                                menu={{
                                    items: versionItems,
                                    selectable: true,
                                    onClick: (e) => updateConfig('lin_version', e.key),
                                }}
                            >
                                <Button>
                                    <Space>{selectedConfig.lin_version || 'Select LIN Version'}</Space>
                                </Button>
                            </Dropdown>
                        </Form.Item>
                    </Form>
                </Collapse.Panel>
            </Collapse>
    );
}
